import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { useState } from "react";
import CreateTable from "./createTable-components/CreateTableButton";
import TableList from "./TableList";
import NewTableCreation from "./createTable-components/NewTableCreation"

export default function Schema({ initialSchema, name, privKey, secret, loadedMoat, setError, setSuccess }) {
    const [expanded, setExpanded] = useState(initialSchema === name)
    const [mouseEnter, setMouseEnter] = useState(false)
    const [addTable, setAddTable] = useState(false)

    return(
        <>
            <Accordion
                defaultExpanded={initialSchema === name}
                onChange={(expanded) => setExpanded(expanded)}
                disableGutters
                sx={{
                  width: "100%",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                }}
                onMouseEnter={() => setMouseEnter(true)} onMouseLeave={() => setMouseEnter(false)}
            >
                <AccordionSummary
                    sx={{
                        "& .MuiAccordionSummary-content": { margin: 0 },
                        "&.MuiAccordionSummary-root": {
                          maxHeight: "38px",
                          minHeight: "38px",
                          padding: "0px 8px",
                        },
                      }}
                      expandIcon={
                        <ExpandMore
                            sx={{ color: mouseEnter ? "#118EA0" : "#fff" }}
                            onMouseEnter={() => setMouseEnter(true)}
                            onMouseLeave={() => setMouseEnter(false)}
                        />}
                >
                    <Typography
                        sx={{color: mouseEnter ? "#118EA0" : "#fff", fontWeight: "bold", fontFamily: "Averta" }}
                        onMouseEnter={() => setMouseEnter(true)}
                        onMouseLeave={() => setMouseEnter(false)}
                    >
                        {name}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails
                    sx={{
                        "&.MuiAccordionDetails-root": {
                          padding: "0px 8px 8px",
                        },
                      }}
                      onMouseEnter={() => setMouseEnter(false)}
                >
                    <div
                        style={{ display: expanded ? "flex" : "none", flexDirection: "column"}}
                    >
                        <TableList
                            schema={name}
                            privKey={privKey}
                            secret={secret}
                            loadedMoat={loadedMoat}
                        />
                        <CreateTable 
                            setAddTable={setAddTable}
                        />
                        <NewTableCreation
                            addTable={addTable}
                            setAddTable={setAddTable}
                            setError={setError}
                            privKey={privKey}
                            loadedMoat={loadedMoat}
                            secret={secret}
                            name={name}
                            setSuccess={setSuccess}
                        />
                    </div>
                </AccordionDetails>
            </Accordion>
        </>
    )
}